import Head from 'next/head'
import { FunctionComponent } from 'react'
import usePageMetadata from '@hooks/usePageMetadata'
import config from '@config'

const {
  appLinks: { iosAppId, iosDeepLinkBaseUrl },
} = config

const SmartBannerMetaTags: FunctionComponent = () => {
  const { url } = usePageMetadata()

  return (
    <Head>
      <meta
        name="apple-itunes-app"
        content={`app-id=${iosAppId}, app-argument=${iosDeepLinkBaseUrl}${url}`}
      />
    </Head>
  )
}

export default SmartBannerMetaTags
